import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  /* Aumentamos o padding na esquerda (de 40px para 100px por exemplo) */
  padding: 40px 40px 40px 100px;
  background-color: ${(props) => props.theme.azulPrincipal};
  border-radius: 8px;
  margin: 20px auto;
  max-width: 90%;
  gap: 40px; /* Espaço entre a foto e o box de texto */

  @media (max-width: 768px) {
    padding: 20px; /* No mobile, reduzimos para não empurrar o texto */
    display: flex;
    flex-direction: column; /* Empilha a foto em cima do texto no celular */
    align-items: center;
    text-align: center; /* Centralizar o texto no mobile costuma ficar melhor */
  }
`

export const Image = styled.img`
  width: 300px; /* Ajuste o tamanho conforme sua preferência */
  height: 300px;
  object-fit: cover;
  border-radius: 50%;
  /* Opcional: margem extra para garantir que saia da borda */
  margin-left: 20px;
`

export const TextContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const Title = styled.h1`
  text-align: center; /* Mantém centralizado dentro do TextContent */
  color: ${(props) => props.theme.azulMuitoClaro};
  font-size: 34px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${(props) => props.theme.brancoFrio};
  padding-bottom: 10px;
  @media (max-width: 768px) {
    font-size: 30px;
  }
`

export const Paragraph = styled.p`
  color: ${(props) => props.theme.azulClaro};
  font-size: 20px;
  line-height: 1.6;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`
